import React from 'react';
import { isCapabilityEnabled } from 'owa-capabilities';
import { headerFullBleedCapability } from 'owa-capabilities-definitions/lib/headerFullBleedCapability';
import { headerMeControlCapability } from 'owa-capabilities-definitions/lib/headerMeControlCapability';
import { novaMeControlCapability } from 'owa-capabilities-definitions/lib/novaMeControlCapability';
import classNames from 'owa-classnames';
import { MeControlLauncher } from 'owa-mecontrol-launcher';
import { getMailboxInfoForMeControl } from 'owa-mecontrol-launcher/lib/utils/getMailboxInfoForMeControl';
import { observer } from 'owa-mobx-react';
import { LazyMeControl as UniversalMeControl } from 'owa-preact-mecontrol';
import { headerFullBleed, headerMeControl } from '../OwaHeader.scss';

const defaultExport: React.FunctionComponent = observer(function OwaHeaderMeControl() {
    if (!isCapabilityEnabled(headerMeControlCapability)) {
        return null;
    }

    const mailboxInfo = getMailboxInfoForMeControl();
    const useNovaMeControl = isCapabilityEnabled(novaMeControlCapability);

    return (
        <div
            className={classNames(
                headerMeControl,
                isCapabilityEnabled(headerFullBleedCapability) && headerFullBleed
            )}
        >
            {useNovaMeControl ? (
                <MeControlLauncher mailboxInfo={mailboxInfo} />
            ) : (
                <UniversalMeControl mailboxInfo={mailboxInfo} />
            )}
        </div>
    );
}, 'OwaHeaderMeControl');

export default defaultExport;
